"use client";

import { ToastVariant, Toast as ToastView } from "@clarityos/ui";
import type { Toast as ToastType } from "react-hot-toast";
import { toast } from "react-hot-toast";

function resolveVariant(t: ToastType): ToastVariant {
  if (t.type === "success") return "success";
  if (t.type === "error") return "error";
  if (t.variant === "warning" || t.variant === "info") return t.variant;
  return "info";
}

interface ToastProps {
  t: ToastType;
}

export function Toast({ t }: ToastProps) {
  const variant = resolveVariant(t);
  const message = typeof t.message === "function" ? t.message(t) : t.message;

  const [title, description] = (() => {
    if (typeof message === "string" && message.includes("\n")) {
      const [first, ...rest] = message.split("\n");
      return [first, rest.join("\n")];
    }
    return [message, undefined];
  })();

  return (
    <ToastView
      variant={variant}
      title={title}
      description={description}
      visible={t.visible}
      onDismiss={() => toast.dismiss(t.id)}
    />
  );
}
